import LegalLayout, { Section } from "../components/LegalLayout";

export default function Cookie() {
  return (
    <LegalLayout title="Cookie Policy" updated="February 2026">
      <p>
        This page explains what cookies and local browser storage Vixelforge uses. We only use what is necessary
        to run the Service — no advertising cookies, no third-party analytics that identify you, no tracking pixels.
      </p>

      <Section heading="Essential cookies">
        <p>
          <strong>session_token</strong> — httpOnly cookie set after you sign in with Google. Required to keep you authenticated.
          Expires after 7 days or when you sign out.
        </p>
        <p>
          <strong>Local storage:</strong> we store your JWT (for email/password sign-in), your chosen UI language, and your cookie-consent decision.
          None of this is shared with third parties.
        </p>
      </Section>

      <Section heading="Third-party cookies">
        <p>
          When you complete a checkout, Stripe sets its own cookies on <code>checkout.stripe.com</code> to run the payment flow securely.
          See <a className="text-orange-400 hover:text-orange-300" href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noreferrer">Stripe's cookie policy</a>.
        </p>
        <p>
          Google may set cookies on <code>accounts.google.com</code> during the "Continue with Google" flow.
          See <a className="text-orange-400 hover:text-orange-300" href="https://policies.google.com/technologies/cookies" target="_blank" rel="noreferrer">Google's cookie policy</a>.
        </p>
      </Section>

      <Section heading="Your choices">
        <p>
          Choosing "Essential only" in the banner keeps all functional cookies but disables any non-essential ones we may add in the future.
          You can also clear cookies at any time from your browser settings; you will need to sign in again.
        </p>
      </Section>
    </LegalLayout>
  );
}
